import { AuthGuard } from 'src/app/core/auth/auth.guard'

import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { CartShowComponent } from './show/show.component'
import { OperationsGuard } from '../operation/operations.guard'

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: CartShowComponent,
        canActivate: [OperationsGuard],
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartRoutingModule {}
